import { render, staticRenderFns } from "./AfSimulate.vue?vue&type=template&id=1624263a&scoped=true&"
import script from "./AfSimulate.vue?vue&type=script&lang=js&"
export * from "./AfSimulate.vue?vue&type=script&lang=js&"
import style0 from "./AfSimulate.vue?vue&type=style&index=0&id=1624263a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624263a",
  null
  
)

export default component.exports